import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationModule } from '@wilson/authorization';
import {
  FilterModule,
  QualificationV2FilterComponent,
  TrainingQualificationV2StatusFilterComponent,
} from '@wilson/filter';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FilterValues } from '../../../../types';

@Component({
  selector: 'wilson-training-qualifications-filter-drawer',
  templateUrl: './training-qualifications-filter-drawer.component.html',
  styleUrls: ['./training-qualifications-filter-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AuthorizationModule,
    FilterModule,
    NzButtonModule,
    NzDividerModule,
    NzDrawerModule,
    NzSelectModule,
    TranslatePipe,
    TrainingQualificationV2StatusFilterComponent,
    QualificationV2FilterComponent,
  ],
})
export class TrainingQualificationsFilterDrawerComponent {
  selectedStatus: string[] = [];
  selectedUserIds: string[] = [];
  selectedQualificationIds: string[] = [];

  @Input() isDrawerVisible!: boolean;
  @Output() closeDrawer = new EventEmitter<void>();
  @Output() applyFilters = new EventEmitter<FilterValues>();

  private filterChangeSubject = new Subject<FilterValues>();

  constructor() {
    this.setupFilterChangeDetection();
  }

  private setupFilterChangeDetection(): void {
    this.filterChangeSubject
      .pipe(
        debounceTime(200),
        distinctUntilChanged((prev, curr) => this.areFiltersEqual(prev, curr)),
      )
      .subscribe((filters) => {
        this.applyFilters.emit(filters);
      });
  }

  onStatusChange(status: string[]): void {
    this.selectedStatus = status;
    this.emitFilterChanges();
  }

  onUserIdsChange(userIds: string[]): void {
    this.selectedUserIds = userIds;
    this.emitFilterChanges();
  }

  onQualificationChange(qualificationIds: string[]): void {
    this.selectedQualificationIds = qualificationIds;
    this.emitFilterChanges();
  }

  private emitFilterChanges(): void {
    this.filterChangeSubject.next({
      status: this.selectedStatus,
      userIds: this.selectedUserIds,
      qualificationIds: this.selectedQualificationIds,
    });
  }

  private areFiltersEqual(prev: FilterValues, curr: FilterValues): boolean {
    return JSON.stringify(prev) === JSON.stringify(curr);
  }
}
